import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { BodyTextSmall } from 'Packages/FacetDesign/Components';
import { FDStack } from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('PlanPageDisclosures', (theme) => ({
  root: {
    padding: theme.spacing(2),
    margin: theme.spacing(2, 0),

  },
}));

export const PlanPageDisclosures = ({ value }) => {
  const classes = useStyles();
  return (
    <div
      id={'disclosures'}
      className={classNames(classes.root)}
    >
      <FDStack direction={'column'} spacing={2}>
        {/* Disabling linter rule because we have nothing better to use here as a key than the array index */}
        {/* eslint-disable-next-line react/no-array-index-key */}
        {value.map((d, i) => <BodyTextSmall value={d} key={i} />)}
      </FDStack>
    </div>
  );
};

PlanPageDisclosures.propTypes = {
  value: PropTypes.array.isRequired,
};
